import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "@/lib/api";
import { Package, MessageCircle } from "lucide-react";

const daysSince = (iso) => (iso ? Math.max(0, Math.floor((Date.now() - new Date(iso).getTime()) / 86400000)) : null);

export const StarterKitPending = ({ asmId }) => {
  const [rows, setRows] = useState(null);

  useEffect(() => {
    const params = { starter_kit: "no", stage: "Approved", ...(asmId ? { asm_id: asmId } : {}) };
    api.get("/affiliates", { params })
      .then((r) => setRows([...r.data].sort((a, b) => (b.onboarding_call_at || "").localeCompare(a.onboarding_call_at || ""))))
      .catch(() => setRows([]));
  }, [asmId]);

  if (!rows) return null;
  return (
    <div data-testid="starter-kit-pending-tile" className="rounded-2xl border border-border/60 bg-card p-6">
      <div className="flex items-center gap-2 mb-4 flex-wrap">
        <Package className="h-5 w-5 text-primary" />
        <h3 className="text-lg font-semibold tracking-tight">Starter Kit Not Purchased Yet</h3>
        <span data-testid="starter-kit-pending-count" className="text-xs font-semibold uppercase tracking-widest bg-primary/10 text-primary rounded-full px-2 py-0.5">{rows.length}</span>
        <span className="ml-auto text-[11px] text-muted-foreground">Newest onboarded first · nudge them this week</span>
      </div>
      {rows.length === 0 ? (
        <div className="text-sm text-muted-foreground py-6 text-center">Everyone on your roster has the starter kit.</div>
      ) : (
        <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-3 max-h-[480px] overflow-y-auto pr-1">
          {rows.map((a) => {
            const d = daysSince(a.onboarding_call_at);
            const phone = (a.phone || "").replace(/\D/g, "");
            return (
              <div key={a.id} data-testid={`starter-kit-pending-${a.id}`} className="rounded-xl border border-border/60 bg-secondary/20 p-4 flex items-center gap-3">
                <Link to={`/affiliates/${a.id}`} className="min-w-0 flex-1 group">
                  <div className="text-sm font-medium truncate group-hover:text-primary transition-colors">{a.name}</div>
                  <div className="text-[11px] text-muted-foreground">
                    {d != null ? `Onboarded ${d}d ago` : "No onboarding call yet"} · {a.tier}
                  </div>
                </Link>
                {phone && (
                  <a
                    data-testid={`starter-kit-pending-wa-${a.id}`}
                    href={`https://wa.me/${phone}`}
                    target="_blank"
                    rel="noreferrer"
                    className="h-8 w-8 rounded-full bg-emerald-500/10 text-emerald-600 flex items-center justify-center hover:bg-emerald-500/20 transition-colors"
                  >
                    <MessageCircle className="h-4 w-4" />
                  </a>
                )}
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
};
